import { loadingLottie } from "assets/lottie";
import {
  black,
  gray7,
  mainDark1Color,
  mainDark3Color,
  white,
} from "assets/styleUtils";
import { Header } from "components";
import { cancelInquiryBox } from "data/company";
import Lottie from "lottie-react";
import moment from "moment";
import {
  getInquiryBoxList,
  IInquiryWithCompanyPicture,
  UpdateListType,
} from "pages/InquiryBoxList/InquiryBoxList";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { headerState } from "recoil/header";
import { getParameterObject } from "utils/common";
import styles from "./style.module.css";

export default function InquiryDetailPage() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const setHeader = useSetRecoilState(headerState);
  const { no, type, status } = getParameterObject({ url: search });
  const [inquiryBoxList, setInquiryBoxList] = useState<
    IInquiryWithCompanyPicture[]
  >([]);
  const hallName: string[] = [];
  const [isLoading, setIsLoading] = useState(true);
  const recombinationList = inquiryBoxList.flatMap((item) => {
    if (!item.sublist) return [];

    return item.sublist
      .map((sub) => {
        const extra_data = [...(item.extra_data || [])];

        extra_data.sort((a, b) => {
          const matchA = a.title?.match(/\d+/);
          const matchB = b.title?.match(/\d+/);

          const numA = matchA ? parseInt(matchA[0], 10) : 0;
          const numB = matchB ? parseInt(matchB[0], 10) : 0;

          return numA - numB;
        });
        const firstPriorityIndex = extra_data.findIndex(
          (data) => data.title === "1순위"
        );

        if (firstPriorityIndex !== -1) {
          const firstPriorityItem = extra_data[firstPriorityIndex];
          const splitContents = firstPriorityItem.content.split(",");
          extra_data.splice(firstPriorityIndex, 1);

          if (splitContents.length > 1) {
            splitContents.forEach((content, index) => {
              if (content.trim() !== "") {
                extra_data.push({
                  title: `${index + 1}순위`,
                  content,
                  category: "counselingDate",
                });
              }
            });
          } else {
            extra_data.push(firstPriorityItem);
          }
        }
        let extraDataTrim = extra_data.filter((data) => !!data.content);
        extraDataTrim.sort((a, b) => {
          const numA = parseInt(a.title.replace("순위", ""), 10);
          const numB = parseInt(b.title.replace("순위", ""), 10);
          return numA - numB;
        });
        extraDataTrim = extraDataTrim.filter(
          (data) =>
            !data.title.includes("제3자") && !data.title.includes("동의")
        );
        // 웨딩홀 홀타입 배열에 추가
        if (sub.no === Number(no) && sub.hall) {
          sub.hall.forEach((_sub) => {
            if (_sub.hall_name) {
              hallName.push(String(_sub.hall_name));
            }
          });
        }
        return {
          ...sub,
          extra_data: extraDataTrim,
        };
      })
      .filter((_item) => _item.no === Number(no));
  });
  const detailData = recombinationList[0];
  const ButtonTag = ({
    backgroundColor,
    label,
    onClick,
  }: {
    backgroundColor: string;
    label: string;
    onClick: () => void;
  }) => (
    <button
      style={{
        width: "80%",
        height: "40px",
        borderRadius: "5px",
        backgroundColor: backgroundColor,
        color: white,
        marginTop: "10px",
      }}
      className={styles.flexCenter}
      onClick={onClick}
    >
      {label}
    </button>
  );
  async function getList() {
    try {
      const {
        data: { result },
      } = await getInquiryBoxList({ type });
      if (!!result) {
        setInquiryBoxList(result);
        setIsLoading(false);
      }
    } catch (error) {
      console.warn("error", error);
    }
  }

  function updateSublist({ no, status }: UpdateListType) {
    setInquiryBoxList((prevData) => {
      return prevData.map((item) => {
        if (item.sublist) {
          const updatedSublist = item.sublist.map((sub) => {
            if (sub.no === no && status !== 3) {
              return { ...sub, status: status, counsel_cancel_day: "yes" };
            }
            return sub;
          });

          return { ...item, sublist: updatedSublist };
        }
        return item;
      });
    });
    setTimeout(() => {
      window.location.href = `/SignIn/InquiryBoxList?type=${type}&status=${status}`;
    }, 500);
  }

  useEffect(() => {
    getList();

    setHeader({
      isVisible: true,
      title: "예약문의 상세보기",
      left: "back",
      url:
        history.length === 1
          ? `/SignIn/InquiryBoxList?type=${type}&status=${
              !!(detailData || []).counsel_cancel_day ? 3 : status
            }`
          : undefined,
    });
  }, []);

  return (
    <>
      <div style={{ padding: "24px" }}>
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: 300,
              padding: 50,
            }}
          >
            <Lottie animationData={loadingLottie} loop={true} />
          </div>
        ) : (
          <>
            <div style={{ display: "flex", lineHeight: "180%" }}>
              <img
                src={detailData?.contructor_img || "/images/homeLogo.png"}
                style={{ width: "100px", height: "100px" }}
              />
              <div
                style={{
                  flexDirection: "column",
                  marginLeft: "10px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div className={styles.dateText}>
                  <div>문의해주신 날짜 :</div>
                  <div>
                    {moment(detailData?.createdAt).format("YYYY-MM-DD")}
                  </div>
                </div>
                <div
                  style={{ color: black, fontSize: "16px", fontWeight: "bold" }}
                >
                  {detailData?.contructor_name}
                </div>
                <div style={{ display: "flex" }}>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {type === "wedding"
                      ? hallName.map((hall, index) => (
                          <div key={index}>
                            {hall}
                            {hallName.length - 1 !== index && <>, &nbsp;</>}
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
            </div>
            <div style={{ marginTop: "30px" }}>
              <div
                style={{
                  width: "100%",
                  height: "40px",
                  backgroundColor: gray7,
                  display: "flex",
                  alignItems: "center",
                  padding: "0 10px",
                }}
              >
                {Number(status) === 2 ? "계약정보" : "예약정보"}
              </div>
              {(() => {
                switch (Number(status)) {
                  case 1:
                    const isCounselDaysValid =
                      !detailData.counsel_days?.includes("00");

                    return (
                      <>
                        <ul>
                          {type === "wedding" && (
                            <li
                              style={{
                                display: "flex",
                                padding: "5px 10px",
                                lineHeight: "180%",
                              }}
                            >
                              <span className={styles.titleStyle}>
                                상담 예약일
                              </span>
                              <span className={styles.boldTitleStyle}>
                                {isCounselDaysValid && detailData.counsel_days}
                                {isCounselDaysValid && detailData.counsel_days
                                  ? `(${moment(detailData.counsel_days).format(
                                      "dd"
                                    )})`
                                  : ""}
                              </span>
                              <span
                                className={styles.boldTitleStyle}
                                style={{ marginLeft: "10px" }}
                              >
                                {isCounselDaysValid && detailData.counsel_time}
                              </span>
                            </li>
                          )}
                          {type === "etc" && (
                            <li
                              style={{
                                display: "flex",
                                padding: "5px 10px",
                                lineHeight: "180%",
                              }}
                            >
                              <span className={styles.titleStyle}>
                                상담 예약일
                              </span>
                              <span className={styles.boldTitleStyle}>
                                {isCounselDaysValid &&
                                detailData.counsel_open_day
                                  ? detailData.counsel_open_day
                                  : detailData.counsel_days}

                                {isCounselDaysValid &&
                                detailData.counsel_open_day
                                  ? `(${moment(
                                      detailData.counsel_open_day
                                    ).format("dd")})`
                                  : detailData.counsel_days
                                  ? `(${moment(detailData.counsel_days).format(
                                      "dd"
                                    )})`
                                  : ""}
                              </span>
                              <span
                                className={styles.boldTitleStyle}
                                style={{ marginLeft: "10px" }}
                              >
                                {isCounselDaysValid &&
                                detailData.counsel_open_time
                                  ? detailData.counsel_open_time
                                  : detailData.counsel_time}
                              </span>
                            </li>
                          )}
                          {(detailData?.extra_data || []).map((data, index) => (
                            <li
                              key={index}
                              style={{
                                display: "flex",
                                padding: "5px 10px",
                                lineHeight: "180%",
                              }}
                            >
                              <div
                                className={
                                  (styles.boldTitleStyle, styles.titleStyle)
                                }
                              >
                                {data.title.replace(/\[|\]/g, "")}
                              </div>
                              <div>{data.content + " "}</div>
                            </li>
                          ))}
                        </ul>
                        {detailData?.status === 1 &&
                          !detailData?.counsel_cancel_day && (
                            <div
                              style={{
                                marginTop: "30px",
                                flexDirection: "column",
                              }}
                              className={styles.flexCenter}
                            >
                              <ButtonTag
                                backgroundColor={mainDark1Color}
                                label="계약 포인트 신청하기"
                                onClick={() => {
                                  if (detailData.category === "웨딩홀") {
                                    navigate(
                                      `/SignIn/MyPointList/PointApplyPage?company=${detailData?.contructor_name}&companyNo=${detailData.no}&category=weddinghall`
                                    );
                                  } else {
                                    navigate(
                                      `/SignIn/MyPointList/PointApplyPage?company=${detailData?.contructor_name}&companyNo=${detailData.no}&category=etc`
                                    );
                                  }
                                }}
                              />
                              {/* TODO: 계약하지 않았음 추후 api추가작업 */}
                              {/* <ButtonTag
                                backgroundColor={mainDark3Color}
                                label="계약하지 않았음"
                                onClick={() => {
                                  cancelInquiryBox({
                                    estimate_no: detailData.estimate_no,
                                    estimate_sub_no: detailData.no,
                                    counsel_cancel_reason: "계약하지 않았음",
                                  });
                                  updateSublist({
                                    no: detailData.no,
                                    status: 1,
                                  });
                                }}
                              /> */}
                            </div>
                          )}
                      </>
                    );
                  case 2:
                    const contractDay = detailData?.contract;
                    const weddingDay =
                      ((contractDay || {}).wedding_day || "").split(" ")[0] ||
                      "";
                    const weddingTime =
                      ((contractDay || {}).wedding_day || "").split(" ")[1] ||
                      "";
                    const contractAddArray = [
                      { title: "예식일", content: weddingDay || "" },
                      {
                        title: "상담일",
                        content:
                          (!detailData.counsel_days?.includes("00") &&
                            detailData.counsel_days) ||
                          "",
                      },
                    ];

                    return (
                      <ul>
                        {type === "wedding" &&
                          (contractAddArray || []).map((data, index) => {
                            return (
                              <li
                                key={index}
                                style={{
                                  display: "flex",
                                  padding: "5px 10px",
                                  lineHeight: "180%",
                                }}
                              >
                                <div className={styles.titleStyle}>
                                  {data.title}
                                </div>
                                <div>
                                  <span style={{ marginRight: "5px" }}>
                                    {data.content || ""}
                                  </span>
                                  <span style={{ marginRight: "10px" }}>
                                    {!data.content.includes("00") &&
                                    data.content
                                      ? `(${moment(data.content).format("dd")})`
                                      : ""}
                                  </span>
                                  <span>{weddingTime || ""} </span>
                                </div>
                              </li>
                            );
                          })}
                        {type === "etc" && (
                          <li
                            style={{
                              display: "flex",
                              padding: "5px 10px",
                              lineHeight: "180%",
                            }}
                          >
                            <div className={styles.titleStyle}>계약일자</div>
                            <div>
                              <span style={{ marginRight: "5px" }}>
                                {detailData.contract_day || ""}
                              </span>
                              <span style={{ marginRight: "10px" }}>
                                {detailData.contract_day &&
                                  !detailData.contract_day.includes("00") &&
                                  moment(detailData.contract_day).format("dd")}
                              </span>
                            </div>
                          </li>
                        )}
                        {(detailData?.extra_data || []).map((data, index) => (
                          <li
                            key={index}
                            style={{
                              display: "flex",
                              padding: "5px 10px",
                              lineHeight: "180%",
                            }}
                          >
                            <div
                              className={
                                (styles.boldTitleStyle, styles.titleStyle)
                              }
                            >
                              {data.title}
                            </div>
                            <div>{data.content + " "}</div>
                          </li>
                        ))}
                      </ul>
                    );

                  default:
                    return (
                      <>
                        {(detailData?.extra_data || []).map((data, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              padding: "5px 10px",
                              lineHeight: "180%",
                            }}
                          >
                            <div
                              style={{ width: "100px", wordBreak: "keep-all" }}
                            >
                              {data.title}
                            </div>
                            <div>{data.content + " "}</div>
                          </div>
                        ))}
                      </>
                    );
                }
              })()}
            </div>
          </>
        )}
      </div>
    </>
  );
}
